import { render, staticRenderFns } from "./EmployersLink.vue?vue&type=template&id=490df74d&"
var script = {}
import style0 from "./EmployersLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports